import { db } from '../firebase';
import { doc, getDoc, setDoc, updateDoc, increment, arrayUnion, collection } from 'firebase/firestore';

// Track visitor in root /visitors collection
export const trackVisit = async (scenarioName, userEmail) => {
  try {
    // Create metrics document in the subcollection, similar to preferences
    const metricsDoc = doc(collection(db, 'companies', scenarioName, 'metrics'), new Date().toISOString().split('T')[0]);
    
    const docSnap = await getDoc(metricsDoc);
    if (!docSnap.exists()) {
      await setDoc(metricsDoc, {
        messages: 0,
        visitors: [userEmail],
        date: new Date().toISOString().split('T')[0]
      });
    } else {
      await updateDoc(metricsDoc, {
        visitors: arrayUnion(userEmail)
      });
    }
  } catch (error) {
    console.error('Error tracking visit:', error);
  }
};

// Track messages per company per day
export const trackMessage = async (scenarioName) => {
  try {
    const metricsDoc = doc(collection(db, 'companies', scenarioName, 'metrics'), new Date().toISOString().split('T')[0]);
    
    const docSnap = await getDoc(metricsDoc);
    if (!docSnap.exists()) {
      await setDoc(metricsDoc, {
        messages: 1,
        visitors: [],
        date: new Date().toISOString().split('T')[0]
      });
    } else {
      await updateDoc(metricsDoc, {
        messages: increment(1)
      });
    }
  } catch (error) {
    console.error('Error tracking message:', error);
  }
};

export const trackInteraction = async (scenarioName) => {
  try {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    
    const metricsRef = doc(db, 'metrics', `${scenarioName}_${today.toISOString().split('T')[0]}`);
    
    await setDoc(metricsRef, {
      scenario: scenarioName,
      date: today,
      messages: 1,  // Just mark that there was an interaction
      lastUpdated: today
    }, { merge: true });
    
  } catch (error) {
    console.error('Error tracking interaction:', error);
  }
}; 